import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class DefineService {

  dtTable: any | null = null;
  passedFacility: string = '';
  pageTypeBool: boolean = false;
  standerdPassedFacility: string = '';
  standerdPageTypeBool: boolean = false;

  constructor(private http: HttpClient) { }

  GetAllFacilities(data: any) {
    return this.http.post(AUTH_API + `/facilities/GetAllFacilities`, data)
  }
  GetQuarterDataFacility(id: any, date: any) {
    return this.http.get(AUTH_API + `/facilities/GetFacilityGoals?facilityId=${id}&passingYear=${date}`)
  }
  AddQualityGoals(id: any, date: any, quater: any) {
    var url = AUTH_API + `/facilities/CheckQualityGoalExist?facilities=${id}&timeframe=${date}&quater=${quater}`
    return this.http.get(url)
  }
  SaveSelectedQuartersAndDate(obj: any) {
    return this.http.post(AUTH_API + '/facilities/Save', obj);
  }
  SaveFacilitySpec(facilityID: any, obj: any) {
    return this.http.post(AUTH_API + `/facilities/FacilitySpecs?fac_key=${facilityID}`, obj);
  }
  GetFacilityDetailByFacilityId(facilityID: any) {
    return this.http.get(AUTH_API + `/facilities/GetFacilityDetailByFacilityId?fac_key=${facilityID}`);
  }
  GetFacilityContact(facilityID: any, obj: any) {
    return this.http.post(AUTH_API + `/facilities/GetFacilityContact?fac_key=${facilityID}`, obj);
  }
  CreateFacilityContact(obj: any) {
    return this.http.post(AUTH_API + '/facilities/CreateFacilityContact', obj);
  }
  EditFacilityContact(obj: any) {
    return this.http.post(AUTH_API + '/facilities/EditFacilityContact', obj);
  }
  RemoveFacilityContact(cnt_key: any) {
    return this.http.post(AUTH_API + `/facilities/RemoveFacilityContact/${cnt_key}`, "");
  }

  PassingSearchFacility(searchField:string, pageTypeBool: boolean){
    this.passedFacility = searchField;
    this.pageTypeBool = pageTypeBool;
  }

  GetSearchFacility(){
    return {passedFacility: this.passedFacility, pageTypeBool: this.pageTypeBool};
  }

  setDtTable(dt: any){
    this.dtTable = dt;
  }

  getDtTable(): any | null {
    return this.dtTable;
}

}
